<div class="stage-editor-modal" *ngIf="visible">
  <div class="modal-backdrop" (click)="onClose()"></div>
  <div class="modal-content">
    <div class="modal-header">
      <h4>{{ editingStage?.id ? '編輯階段' : '新增階段' }}</h4>
      <button class="btn-close" (click)="onClose()">
        <i class="fas fa-times"></i>
      </button>
    </div>
    
    <div class="modal-body" *ngIf="editingStage">
      <div class="form-group">
        <label>階段名稱 *</label>
        <input type="text" 
               class="form-control"
               [(ngModel)]="editingStage.name"
               placeholder="例如：申請人基本資訊">
      </div>
      
      <div class="form-group">
        <label>階段說明</label>
        <textarea class="form-control"
                  [(ngModel)]="editingStage.description"
                  placeholder="簡述此階段的用途和要求"
                  rows="3"></textarea>
      </div>
      
      <div class="form-group">
        <label>負責部門</label>
        <div class="department-input">
          <input type="text" 
                 class="form-control"
                 [(ngModel)]="departmentInput"
                 placeholder="輸入部門名稱"
                 (keypress)="onKeyPress($event)">
          <button class="btn btn-sm btn-primary" (click)="addDepartment()">
            <i class="fas fa-plus"></i>
          </button>
        </div>
        <div class="selected-departments" *ngIf="editingStage.requiredDepartments.length > 0">
          <span class="department-tag" 
                *ngFor="let dept of editingStage.requiredDepartments">
            {{ dept }}
            <button class="remove-dept" (click)="removeDepartment(dept)">
              <i class="fas fa-times"></i>
            </button>
          </span>
        </div>
      </div>
      
      <div class="form-group">
        <label>排序順序</label>
        <input type="number" 
               class="form-control"
               [(ngModel)]="editingStage.order"
               min="1">
      </div>
    </div>
    
    <div class="modal-footer">
      <button class="btn btn-primary" 
              (click)="onSave()"
              [disabled]="!isValidStage()">儲存</button>
      <button class="btn btn-secondary" (click)="onClose()">取消</button>
    </div>
  </div>
</div>